import { Box, Checkbox, Typography } from '@sbv-clients/ui-shared';
import { FunctionComponent } from '@sbv-clients/util-misc';

interface Props {
  title: string;
  onClick: () => void;
  checked: boolean;
  disabled?: boolean;
}

export const CheckBoxWithLabel: FunctionComponent<Props> = ({
  title,
  onClick,
  checked,
  disabled,
}) => {
  return (
    <Box
      onClick={disabled ? undefined : onClick}
      display="flex"
      alignItems="center"
      sx={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <Checkbox checked={checked} disabled={disabled} />
      <Typography style={{ fontSize: '14px' }}>{title}</Typography>
    </Box>
  );
};
